/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import PostPreview from 'app/components/common/PostPreview.jsx';
import SocialListModule from 'app/mixins/SocialListModule.js';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import PostProvider from 'app/redux/Providers/PostProvider.jsx';
import MessageModule from 'app/mixins/MessageModule.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import { Breakpoint } from 'react-socks';
import { Link } from 'react-router-dom';
import DateDisplay from 'app/components/common/DateDisplay.jsx';


class SocialListDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            postPreview: {},
            messages: [],
            editorUrl: (this.props.appName === "dlvr") ? "/config/social/" : "/social/",
        };

        this.editSocialSettings = this.editSocialSettings.bind(this);
        this.editSocialSchedule = this.editSocialSchedule.bind(this);
        this.activeSocialToggle = this.activeSocialToggle.bind(this);
        this.deleteSocial = this.deleteSocial.bind(this);
        this.viewSocial = this.viewSocial.bind(this);
        this.viewSocialLog = this.viewSocialLog.bind(this);
        this.checkAuth = this.checkAuth.bind(this);
        this.repostMethod = this.repostMethod.bind(this);
        SocialListModule.reauthorizeSocial = SocialListModule.reauthorizeSocial.bind(this);
        SocialListModule.reauthorizeSocialClick = SocialListModule.reauthorizeSocialClick.bind(this);
        this.rateLimitClick = this.rateLimitClick.bind(this);

    }

    componentDidMount() {

        if (this.props.app.firstLoad.SOCIAL_LIST === true) {
            if (this.props.social.lastPost !== undefined && this.props.social.lastPost.piID !== undefined) {
                this.props.getPostPreview(this.props.social.lastPost.piID, this.props.social.lastPost.pipID);
            }
        }

        if (parseInt(this.props.social.activeFlag, 10) &&
            !parseInt(this.props.social.sysActionFlag, 10) &&
            this.props.social.postLimit !== undefined &&
            parseInt(this.props.social.postLimit, 10) > 0) {

            // if (dataLayer) {
            //     dataLayer.push({
            //         'event': 'promotionView',
            //         'ecommerce': {
            //             'promoView': {
            //                 'promotions': [
            //                     {
            //                         'id': 'rate_limit_social_detail',
            //                         'name': 'Rate Limit Social Detail',
            //                         'creative': 'rate_limit_social_detail.1',
            //                         'position': 'social_detail'
            //                     }
            //                 ]
            //             }
            //         },
            //         //GA 4 params
            //         'promotion_id': 'rate_limit_social_detail',
            //         'promotion_name': 'Rate Limit Social Detail',
            //         'creative_name': 'rate_limit_social_detail.1',
            //         'creative_slot': 'social_detail',
            //         items: [
            //             {
            //                 item_id: 'dlvrit_1',
            //                 item_name: 'dlvr.it premium plan',
            //                 price: 1.00,
            //                 quantity: 1
            //             }
            //         ]
            //     });
            // }

            if (gtag) {
                gtag('event', 'view_promotion', {
                    'promotion_id': 'rate_limit_social_detail',
                    'promotion_name': 'Rate Limit Social Detail',
                    'creative_name': 'rate_limit_social_detail.1',
                    'creative_slot': 'social_detail',
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            price: 1.00,
                            quantity: 1
                        }
                    ]
                });
            }

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Rate Limit Social Detail'
                });
            }
        }

    }

    componentDidUpdate(prevProps, prevState) {

        // make the post preview call again in case of a race
        if (prevProps.app.firstLoad.SOCIAL_LIST === false && this.props.app.firstLoad.SOCIAL_LIST === true) {
            if (this.props.social.lastPost !== undefined && this.props.social.lastPost.piID !== undefined) {
                this.props.getPostPreview(this.props.social.lastPost.piID, this.props.social.lastPost.pipID);
            }
        }

        if (prevProps.app.loading.SOCIAL_GET_FB_GROUP_STATUS === true && this.props.app.loading.SOCIAL_GET_FB_GROUP_STATUS === false) {
            this.setState({
                isConnectingGroup: false,
                isVerifyingGroup: false
            });
        }
    }


    editSocialSettings(e) {

        let socialId = e.currentTarget.dataset.id;

        this.props.router.navigate(this.state.editorUrl + socialId);

    }

    editSocialSchedule(e) {

        let socialId = e.currentTarget.dataset.id;

        this.props.router.navigate('/queue/schedule/' + socialId);

    }

    activeSocialToggle(e) {
        let active = (e.currentTarget.dataset.togglestate === "true") ? 0 : 1;

        if (active) {
            if (parseInt(this.props.social.sysActionFlag, 10) === 1 && parseInt(this.props.social.activeFlag, 10) === 0) {
                this.props.setAppError({
                    type: 'SOCIAL_UPDATE',
                    error: {
                        id: this.props.social.id,
                        msg: 'Reconnect your account before activating'
                    }
                });

                return;
            }
        }

        let social = _.clone(this.props.social);
        social.activeFlag = active;

        this.props.updateSocial(social);

    }

    deleteSocial(e) {

        let constants = this.props.app.config.constants;
        let msg = 'Are you sure you want to remove this social?';
        if (SocialListModule.hasLinkpage(this.props.social.psID, constants)) {
            msg = (
                <div>
                  {msg}
                  <div style={{fontWeight: "300", "marginTop": "15px", "fontSize": ".9em" }}>Please note: Any Link Page attached to this social will also be deleted.</div>
                </div>
            )
        }


        let socialId = e.currentTarget.dataset.id,
            cancelDelete = () => {
                this.props.closeAllModals();
            },
            confirmDelete = (e) => {
                e.preventDefault();
                this.props.deleteSocial(socialId);
                this.props.closeAllModals();
            },
            modal = (
                <DeleteModal
                    modalCopy={msg}
                    cancelAction={cancelDelete}
                    confirmAction={confirmDelete}/>
            );

        this.props.addModal(modal);

    }

    viewSocial(e) {

        if (this.props.social.link) {
            window.open(this.props.social.link);
        }

    }

    viewSocialLog(e) {

        let socialId = e.currentTarget.dataset.id;

        this.props.router.navigate(this.state.editorUrl + socialId + '/log');

    }

    checkAuth(e) {

        let socialId = e.currentTarget.dataset.id;

        this.props.checkAuth(socialId);

    }

    repostMethod(item) {

        this.props.persistData('repostItem', item);
        this.props.router.navigate("/content/post");

    }

    rateLimitClick(e) {
        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'rate_limit_social_detail',
        //                         'name': 'Rate Limit Social Detail',
        //                         'creative': 'rate_limit_social_detail.1',
        //                         'position': 'social_detail'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'rate_limit_social_detail',
        //         'promotion_name': 'Rate Limit Social Detail',
        //         'creative_name': 'rate_limit_social_detail.1',
        //         'creative_slot': 'social_detail',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'rate_limit_social_detail',
                'promotion_name': 'Rate Limit Social Detail',
                'creative_name': 'rate_limit_social_detail.1',
                'creative_slot': 'social_detail',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'rate_limit_social_detail',
                'promotion_name': 'Rate Limit Social Detail',
            });
        }
    }

    render() {
        let statusBlock = null,
            activeFlag = this.props.social !== undefined && parseInt(this.props.social.activeFlag, 10)
                ? true
                : false,
            sysActionFlag = this.props.social !== undefined && parseInt(this.props.social.sysActionFlag, 10)
                ? true
                : false,
            constants = this.props.app.config.constants,
            lastPostTs = '',
            internalServices = [constants.POST_SVC_FEED],
            messages = [],
            messageText = '',
            messageClass = '',
            errors = '',
            errList = [],
            tokenExpiration = null,
            buttons = {
                edit: null,
                schedule: null,
                reconnect: null,
                errors: null,
                toggle: null,
                view: null,
                delete: null,
                linkpage: null,
                test: null,
                addToFeeds: null,
            },
            postUsage = null,
            postStatus = null,
            extraPostStatus = null;

        if (this.props.social.lastPost !== undefined && this.props.social.lastPost.postTs !== undefined) {
            if (this.props.user.detail.timezone) {
                lastPostTs = moment(this.props.social.lastPost.postTs).tz(this.props.user.detail.timezone).format();
            }
        }

        // show a post status indicator as long as the social is active and has no system error
        if (parseInt(this.props.social.activeFlag, 10)
            && !parseInt(this.props.social.sysActionFlag, 10)
            && this.props.social.postLimit !== undefined
            && parseInt(this.props.social.postLimit, 10) > 0) {

            let totalPosts = parseInt(this.props.social.postLimit),
                remainingPosts = parseInt(this.props.social.postLimitRemaining),
                usedPosts = totalPosts - remainingPosts,
                progressClass = 'posts-status-progress',
                progressWidth = '0',
                postRenewal = new moment(this.props.social.postLimitReset * 1000).tz(this.props.user.detail.timezone);

            if (usedPosts === totalPosts) {
                progressClass += ' full';
            }

            progressWidth = (usedPosts / totalPosts) * 100;

            postStatus = (
                <div className="posts-status">
                    <div className={progressClass}>
                        <div className="progress-bar" style={{width: progressWidth + "%"}}></div>
                    </div>
                    <span className="posts-readout">{usedPosts} / {totalPosts} posts for this social (renews {postRenewal.format("MMM, D")})</span>
                </div>
            );
        }

        if (parseInt(this.props.social.activeFlag, 10)
						&& !parseInt(this.props.social.sysActionFlag, 10)
						&& this.props.social.pubLimit !== undefined
						&& parseInt(this.props.social.pubLimit, 10) > 0) {
            let extraPosts = parseInt(this.props.social.pubLimit),
                extraPostsRemaining = parseInt(this.props.social.pubLimitRemaining),
                extraPostsReset = new moment(this.props.social.pubLimitReset * 1000).tz(this.props.user.detail.timezone),
                extraPostsUsed = extraPosts - extraPostsRemaining,
                extraProgressClass = 'posts-status-progress',
                progressWidth = 0;

            if (extraPostsUsed === extraPosts) {
                extraProgressClass += ' full';
            }

            progressWidth = (extraPostsUsed / extraPosts) * 100;

            extraPostStatus = (
                <div className="posts-status">
                    <div className={extraProgressClass}>
                        <div className="progress-bar" style={{width: progressWidth + "%"}}></div>
                    </div>
                    <span className="posts-readout">
                        <Link to="/account/subscription">
                            {extraPostsUsed} / {extraPosts} shared X posts (renews {extraPostsReset.format("MMM, D")})
                        </Link>
                    </span>
                </div>
            );
        }

        if (postStatus || extraPostStatus) {
            if (!extraPostStatus && !this.props.isFreeUser() && !this.props.isStarterUser()) {
                extraPostStatus = (
                    <Link to="/account/subscription" className="buy-posts">
                        Need more X Posts?
                    </Link>
                );
            }
            postUsage = (
                <div className="post-usage-wrapper">
                    {postStatus}
                    {extraPostStatus}
                </div>
            );
        }

        /*
         * Only display the Reconnect button for external services
         * Also hide it for Facebook Profiles
         */
        if (internalServices.indexOf(parseInt(this.props.social.psID, 10)) === -1) {
            if (!this.props.social.subType ||
                !(
                    parseInt(this.props.social.psID, 10) === constants.POST_SVC_FACEBOOK &&
                    parseInt(this.props.social.subType, 10) === constants.FB_PROFILE
                )
            ) {
                buttons.reauth = (
                    <div className="detail-button" onClick={SocialListModule.reauthorizeSocialClick} data-id={this.props.social.id}
                         data-serviceid={this.props.social.psID}
                         role="button"
                         aria-label="reconnect">
                        <div className="button-icon">
                            <i className={classnames("fa", "fa-refresh", {'error': sysActionFlag})}></i>
                        </div>
                        <div className={classnames("button-label", {'error': sysActionFlag})}>
                            Reconnect
                        </div>
                    </div>
                );
            }

            /*
             * Don't display the Test button when sysActionFlag is set because it just causes confusion if "test" says
             * "we can connect", because then people think they don't have to reconnect.
             */
            if (parseInt(this.props.social.sysActionFlag, 10) !== 1) {
                buttons.test = (
                    <div className="detail-button" onClick={this.checkAuth} data-id={this.props.social.id} role="button" aria-label="test">
                        <div className="button-icon">
                            <i className="fa fa-bolt"></i>
                        </div>
                        <div className="button-label">
                            Test
                        </div>
                    </div>
                );
            }
        }

        /* Only services that have a link page get the button */
        if (SocialListModule.hasLinkpage(this.props.social.psID, constants)) {
            buttons.linkpage = (
                <div className="detail-button"  onClick={SocialListModule.linkpage.bind(this)} data-id={this.props.social.id} role="button" aria-label="Link Page">
                  <div className="button-icon">
                    <i className={classnames("fa", "fa-link", {'error': 0})}></i>
                  </div>
                  <div className={classnames("button-label")}>
                    Link Page
                  </div>
                </div>
            );
        }



        if (this.props.errors !== null && this.props.errors.length !== undefined && this.props.errors.length) {
            errors = (
                <ul className="error-list">
                {
                    this.props.errors.map((error, i) => {
                        return (
                            <li key={i} className="error-list-item">
                                <i className="fa fa-exclamation-circle error"></i>
                                <div className="status-message">
                                    {error}
                                </div>
                            </li>
                        );
                    })
                }
                </ul>
            );

            statusBlock = (
                <div className="detail-status error">
                    {errors}
                </div>
            );
        } else if (parseInt(this.props.social.sysActionFlag, 10) === 1) {
            if ((parseInt(this.props.social.psID, 10) === constants.POST_SVC_FACEBOOK && parseInt(this.props.social.subType, 10) === constants.FB_PROFILE)) {
                statusBlock = null;
            } else {
                let link = (
                    <span className="detail-link" onClick={SocialListModule.reauthorizeSocial} data-id={this.props.social.id} data-serviceid={this.props.social.psID} role="button" aria-label="reconnect social"> Reconnect now</span>
                );
                if (this.props.appName === "dlvr" && this.props.social.clientPubID !== 0) {
                    let client = this.props.subaccounts.list.find((subaccount) => { return this.props.social.clientPubID === subaccount.id; });
                    link = (
                        <span> Please contact {client.clientName} to reconnect.</span>
                    );
                }
                statusBlock = (
                    <div className="detail-status error">
                        <i className="fa fa-exclamation-circle error"></i>
                        <div className="status-message">
                            We can’t connect to this social.
                            {link}
                        </div>
                    </div>
                );
            }

        }

        /*
         * Messages need to come after errors, otherwise actions like 'test' can be completely invisible
         */
        messages = this.props.getAppMessages(['SOCIAL_CHECK_AUTH', 'SOCIAL_UPDATE']);
        if (messages.length) {
            statusBlock = (
                <MessageModule
                    app={this.props.app}
                    keys={['SOCIAL_CHECK_AUTH', 'SOCIAL_UPDATE']}
                    render={(state) => {
                        return (
                            <div className="detail-status info">
                                {state.messages.map((message) => {
                                    return (
                                        <span key={message.id}>
                                            {message.message}<br/>
                                        </span>
                                    );
                                })}
                            </div>
                        );
                    }}/>
            );
        }

        if (this.props.social.link) {
            buttons.view = (
                <div className="detail-button" onClick={this.viewSocial} data-id={this.props.social.id} role="button" aria-label="view social">
                    <div className="button-icon">
                        <i className="fa fa-external-link"></i>
                    </div>
                    <div className="button-label">
                        View
                    </div>
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_LINKEDIN) {
            if (parseInt(this.props.social.expiration, 10) > 0) {
                let now = new Date().getTime(),
                    time = this.props.social.expiration * 1000,
                    formattedTime = null;

                if (parseInt(this.props.social.sysActionFlag, 10) !== 1) {
                    if (time <= now) {
                        tokenExpiration = (
                            <div className="token-expire-msg">
                                <i className="fa fa-warning"></i>&nbsp;LinkedIn requires dlvr.it to reconnect your page every 12 months. {"You'll"} need to <a href='#' data-id={this.props.social.id} data-serviceid={this.props.social.psID} onClick={SocialListModule.reauthorizeSocial}>reconnect</a> this page now
                            </div>
                        );
                    }
                }
            }
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_FACEBOOK) {
            if (parseInt(this.props.social.subType, 10) === constants.FB_PROFILE) {
                tokenExpiration = (
                    <div className="token-expire-msg">
                        <i className="fa fa-warning"></i>&nbsp;Facebook profiles are no longer supported.&nbsp;
                        <a href='https://support.dlvrit.com/hc/en-us/articles/360007291174' target="_blank">Read details on recent changes</a>
                    </div>
                );
            }
            if (parseInt(this.props.social.subType, 10) === constants.FB_GROUP) {
                let fbAppUrl = "https://support.dlvrit.com/hc/en-us/articles/24787142311323-Facebook-Groups-support-ending-April-22-2024";
                tokenExpiration = (
                    <div className="token-expire-msg flex-version">
                        <i className="fa fa-warning"></i>
                        <div>
                            Meta is shutting down the Facebook Groups API on April 22, 2024. dlvr.it will no longer be able to post to Facebook Groups after this date.&nbsp;
                            <Link to={fbAppUrl}>
                                Details
                            </Link>
                        </div>
                    </div>
                );
            }
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_BLOGGER) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Heads up, Blogger is limited to 5 posts per day.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_REDDIT) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Heads up, Reddit is limited to 5 posts per day.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_WORDPRESS) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Heads up, Wordpress is limited to 5 posts per day.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID,10) === constants.POST_SVC_INSTAGRAM_BUSINESS) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Instagram limits accounts to 50 API-published posts within a 24-hour moving period.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_PINTEREST) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Posting to Pinterest Boards is limited to 25 items per day.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_NEXTDOOR) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Posting to Nextdoor is currently limited to 25 items per day.&nbsp;
                </div>
            );
        }

        if (parseInt(this.props.social.psID, 10) === constants.POST_SVC_TIKTOK) {
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-bell-o"></i>&nbsp;Posting to TikTok is currently limited to 15 items per day.&nbsp;
                </div>
            );
        }

        buttons.toggle = (
            <div className="detail-toggle">
                <ToggleControl active={activeFlag} callback={this.activeSocialToggle}/>
            </div>
        );

        buttons.edit = (
            <div className="detail-button" onClick={this.editSocialSettings} data-id={this.props.social.id} role="button" aria-label="edit social">
                <div className="button-icon">
                    <i className="fa fa-pencil"></i>
                </div>
                <div className="button-label">
                    Edit
                </div>
            </div>
        );

        // have a feeling it'll be back -- 6/17/24
        // buttons.schedule = (
        //     <div className="detail-button" onClick={this.editSocialSchedule} data-id={this.props.social.id} role="button" aria-label="view social schedule">
        //         <div className="button-icon">
        //             <i className="icon ion-android-alarm-clock"></i>
        //         </div>
        //         <div className="button-label">
        //             Posting Times
        //         </div>
        //     </div>
        // );

        let hasLogEntries = null;
        if (this.props.social.errList && this.props.social.errList.length) {
            hasLogEntries = (
                <div className="error-indicator"></div>
            );
        }
        buttons.errors = (
            <div className="detail-button" onClick={this.viewSocialLog} data-id={this.props.social.id} role="button" aria-label="view errors">
                <div className="button-icon">
                    <i className="fa fa-history"></i>{hasLogEntries}
                </div>
                <div className="button-label">
                    Errors
                </div>
            </div>
        );

        buttons.delete = (
            <div className="detail-button" onClick={this.deleteSocial} data-id={this.props.social.id} role="button" aria-label="delete social">
                <div className="button-icon">
                    <i className="fa fa-trash-o"></i>
                </div>
                <div className="button-label">
                    Delete
                </div>
            </div>
        );

        buttons.calendar = (
            <div className="detail-button" onClick={(e) => {
                this.props.router.navigate(`/queue/calendar/${this.props.social.id}`);
            }} role="button" aria-label="view calendar">
                <div className="button-icon">
                    <i className="icon ion-android-calendar"></i>
                </div>
                <div className="button-label">
                    Calendar
                </div>
            </div>
        )

        // Feeds are a dlvr-app concept: clients only connect socials, and the client
        // tree never receives the feed props App.jsx injects, so keep this out of it.
        let canAddToFeeds = this.props.appName !== "client"
            && typeof this.props.userHasFeeds === "function"
            && typeof this.props.showSuggestFeedsModal === "function"
            && this.props.userHasFeeds()
            && this.props.user.detail.routeViewType === constants.ROUTE_VIEW_SIMPLE;

        if (canAddToFeeds && parseInt(this.props.social.psID,10) !== constants.POST_SVC_INSTAGRAM_BUSINESS) {
            buttons.addToFeeds = (
                <div className="detail-button" onClick={(e) => {
                    this.props.showSuggestFeedsModal(this.props.social.id);
                }} role="button" aria-label="add to feeds">
                    <div className="button-icon">
                        <i className="icon ion-social-rss"></i>
                    </div>
                    <div className="button-label">
                        Add to Feeds
                    </div>
                </div>
            );
        }

        if (this.props.appName === "client") {
            buttons.toggle = null;
            buttons.edit = null;
            buttons.schedule = null;
            tokenExpiration = (
                <div className="token-expire-msg">
                    <i className="fa fa-warning"></i>&nbsp;This profile is managed by {this.props.user.detail.clientInfo.organization}.
                </div>
            );
        }


        return (
            <div>
                <Breakpoint desktop only>
                    <div className="detail-controls">
                        <div className="detail-buttons">
                            {buttons.toggle}
                            {buttons.edit}
                            {buttons.calendar}
                            {buttons.checkAuthButton}
                            {buttons.errors}
                            {buttons.reauth}
                            {buttons.view}
                            {buttons.addToFeeds}
                            {buttons.linkpage}
                            {buttons.delete}
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="detail-controls mobile">
						<div className="detail-control-row">
                            {buttons.toggle}
                            {buttons.reauth}
                            {buttons.delete}
                        </div>
                        <div className="detail-control-row">
                            {buttons.edit}
                            {buttons.calendar}
                            {buttons.checkAuthButton}
                            {buttons.errors}
                            {buttons.view}
                            {buttons.addToFeeds}
                            {buttons.linkpage}
                        </div>
                    </div>
                </Breakpoint>
                {statusBlock}
                {postUsage}
                {tokenExpiration}
                <div className="post-history solo">
                    <div className="last-detail-posted">
                        {(this.props.appName === "dlvr") ? (
                            <PostPreview user={this.props.user}
                                context="social"
                                preview={this.props.posts.preview}
                                postTime={lastPostTs}
                                repostMethod={this.repostMethod}/>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

};

SocialListDetail.displayName = "SocialListDetail";

SocialListDetail.propTypes ={
    social: PropTypes.object,
    lastPost: PropTypes.object,
    messages: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    errors: PropTypes.object,
    setModal: PropTypes.func,
    showSuggestFeedsModal: PropTypes.func,
    userHasFeeds: PropTypes.func
};

SocialListDetail.defaultProps = {
    social: {},
    lastPost: null,
    messages: null,
    errors: null,
    setModal: null,
    showSuggestFeedsModal: null,
    userHasFeeds: null
};

const enhance = compose(
    PostProvider
);

export default enhance(SocialListDetail);
